import React from 'react';
import { connect } from 'react-redux'
import { Spin } from 'antd';

const Loaded = ({IRI}) => <span>{IRI}&nbsp;<Spin size="small" /></span>

/** Отображение элемента по ссылки. В качестве параметров:
 * 1. IRI Объекта - IRI который, необходимо показать
 * 2. factory - фабрика, используемые для получения наименование
 * 3. triplet - информация об записи. Может включать в себя:
 *   - URI ObjectProperty - URI объектного свойства, которое содержало IRI (опциональной)
 *   - языковую константу
 *   - IRI объекта,
 * например { "predicat": { "type": "uri", "value": "http://purl.org/dc/terms/creator" }	, 
 *            "object"  : { "type": "uri", "value": "http://hbz.ru/adms/dan_brickley", "xml:lang": "ru" }}
 * 4. lang - текущий язык
 * 5. graph - граф с данным
 */ 
export class BaseViewLinkComponent extends React.Component {

  state = {
    loaded: true,
    value: undefined
  };
  componentWillMount() {
    const { value } = this.state;
    if ((value==undefined)|| (value==null)) 
        this.makeValue();
  }

  componentWillReceiveProps(nextProps){
      const { value } = this.state;
      if ((value==undefined)|| (value==null)) 
          this.makeValue();
  }

  makeValue () {
    const { IRI, factory, triplet, lang, graph } = this.props;
    this.setState({loaded: true})
    if (!factory){  //Фабрика отсутствует
      this.setState({loaded: false, value: IRI});
      return;
    };//Данные уже считали
    if ((triplet)&&triplet["rdfs:label"]){
      this.setState({loaded: false, value: triplet["rdfs:label"]});
      return;
    }
    if (!this.props.dispatch)
      this.setState({loaded: false, value: IRI});
    else
      this.props.dispatch(factory.provider.getLabelByIRI(IRI, lang, triplet))
        .then(response => {
          this.setState({loaded: false, value: response.label});      
        })
        .catch(e => { 
          console.log("Error!", e);
      });
  }

  render(){
    const { IRI } = this.props;
    const {loaded, value} = this.state;
    return(
      (loaded?
        <Loaded IRI={IRI} />:
        <span>{value}</span>
      )
    )
  }
}

function mapStateToProps(state, props) {
  //Значения в store redux. vset - для значений по умолчнию, vowl
  const {vset} = state;
  //Параметры, которые могут прийти из настроек
  const {graph, IRI, lang, triplet, factory } = props;
  // //Ищем считанные из значения свойств
  // const subset = (values && Array.isArray(values))? factory.provider.subsetValuesByURI(values, iri):[];
  return {
    IRI,
    factory,
    triplet,
    graph: (graph)? graph: vset.graph,
    lang: (lang)?lang: vset.lang,
  };
}

/** Компонента, смапированная на vset */
export const SimpleViewLinkComponent = connect(mapStateToProps)(BaseViewLinkComponent);